<template>
  <select :id="id" :name="name" class="form-control all-day-input" @change="changePartOfDay">
    <option v-for="(part,i) in parts"  :selected=" value==part[2]" :data-start="part[0]"
      :data-end="part[1]">
      {{ part[2] }}
    </option>
  </select>
</template>
<script>

import {EventBus} from "@/events/event-bus";

export default {
  name: "PartOfDayVisitDropDown",
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
      service: {
          type: Object,
          required: true
      },
    index: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      parts: [
          ["00:00","23:59","Anytime (12 - 12 AM)"],
          ["01:00","03:59","Early morning (1 - 4 AM)"],
          ["04:00","05:59","Dawn (4 - 6 AM)"],
          ["06:00","08:59","Morning (6 - 9 AM)"],
          ["09:00","11:59","Mid-morning (9 - 12 PM)"],
          ["12:00","13:59","Noon (12 - 2 PM)"],
          ["14:00","15:59","Afternoon (2 - 4 PM)"],
          ["16:00","20:59","Evening (4 - 9 PM)"],
          ["21:00","23:59","Night (9 - 12 AM)"],
          ["00:00","00:59","Mid-night (12 - 1 AM)"],
      ]
    }
  },
  computed: {

  },
  methods: {
    changePartOfDay(event){
       this.$emit("input",event.target.value)
        this.changePartOfDayEvent(this.index)
    },
    changePartOfDayEvent(counter) {
      /**
       * @date   2022
       *@variable service_estimate_hours ===>>> service time
       *@variable partOfDay_begin ===>>>start time
       *  when user change Part Of Day  from admin ==>>  calculate booking end time depends on  service time and  booking start time
       * @example ===>>   partOfDay_begin=10:00 and  service_estimate_hours = 2hours   results ==>> partOfDay_end =10:00 + 2hours ==>> 12:00
       *  getBookingStartAndEnd2
       */

      var partOfDay = $("#partOfDay_" + counter).find('option:selected');
      var partOfDay_begin = partOfDay.data('start');
      var partOfDay_end = partOfDay.data('end');

      var service_estimate_hours = $("#service_estimate_hours" + counter).val();
      var hour_min = partOfDay_begin;
      var hour_min_ar = hour_min.split(":");
      var Hour = hour_min_ar[0];
      Hour = this.pad(Hour, 2);
      var min = hour_min_ar[1];
      min = this.pad(min, 2);
      /**   check service estimate hours if not empty and not equal to zero ==>>> because if = 0 returns invalid end time   from admin   **/

      if (service_estimate_hours && ( service_estimate_hours != 0 || service_estimate_hours != "0")) {

        // get the end hour by adding the service time to the starting hour
        var endHour = parseInt(Hour) + parseInt(service_estimate_hours);
        endHour = this.pad(endHour, 2);
        var serviceTimeMin = 60 * (parseFloat(service_estimate_hours) - parseInt(service_estimate_hours));
        // get the end minutes
        var endMin = parseInt(min) + parseInt(serviceTimeMin);
        if (endMin >= 60) {
          endMin = endMin - 60;
          endHour = parseInt(endHour) + 1;
        }
        endMin = this.pad(endMin, 2);
        var days_to_add = 0;
        if (endHour >= 24) {
          days_to_add = endHour / 24;
          endHour = endHour % 24;
        }
        partOfDay_begin = Hour + ':' + min; //24 hour
        partOfDay_end = endHour + ':' + endMin;
        /**      calculate  booking end  time depends on  service time and  booking start time     getBookingStartAndEnd2  **/
      }
      EventBus.$emit("partOfDayDropDownChanged",partOfDay_begin,partOfDay_end)

    },
    pad(str, max) {
      str = str.toString();
      return str.length < max ? this.pad("0" + str, max) : str;
    }
  }
}
</script>